import { DvaReducer } from '@/models/shared';
import { AnyAction } from 'redux';
import { EffectsCommandMap, Subscription } from 'dva';
import { AVATAR_URL_PREFIX } from '@/constants';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import dayjs from 'dayjs';

export interface DashboardPageModelState {
  resourceStatistic: {
    totalProfit: string;
    lastWeekProfit: string;
    lastWeekContract: string;
  };

  latestResources: {
    resourceID: string;
    resourceName: string;
    resourceTitle: string;
    cover: string;
    type: string[];
    policies: string[];
    dataTime: string;
    detailUrl: string;
    editUrl: string;
    updateUrl: string;

    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;
    // isCollection: boolean;
  }[];

  nodeStatistic: {
    totalProfit: string;
    lastWeekProfit: string;
    lastWeekContract: string;
  };

  allNode: {
    nodeID: string;
    nodeDomain: string;
    nodeName: string;
    displayUrl: string;
    managingUrl: string;
  }[];
}

export interface ChangeAction extends AnyAction {
  type: 'change';
  payload: Partial<DashboardPageModelState>;
}

export interface OnMount_Page_Action extends AnyAction {
  type: 'dashboardPage/onMount_Page';
}

export interface OnUnmount_Page_Action extends AnyAction {
  type: 'dashboardPage/onUnmount_Page';
}

export interface FetchInfoAction extends AnyAction {
  type: 'fetchInfo';
}

interface DashboardPageModelType {
  namespace: 'dashboardPage';
  state: DashboardPageModelState;
  effects: {
    onMount_Page: (action: OnMount_Page_Action, effects: EffectsCommandMap) => void;
    onUnmount_Page: (action: OnUnmount_Page_Action, effects: EffectsCommandMap) => void;
    fetchInfo: (action: FetchInfoAction, effects: EffectsCommandMap) => void;
  };
  reducers: {
    change: DvaReducer<DashboardPageModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: DashboardPageModelState = {
  resourceStatistic: {
    totalProfit: '--',
    lastWeekProfit: '--',
    lastWeekContract: '--',
  },

  latestResources: [],

  nodeStatistic: {
    totalProfit: '--',
    lastWeekProfit: '--',
    lastWeekContract: '--',
  },

  allNode: [],
};

const Model: DashboardPageModelType = {
  namespace: 'dashboardPage',
  state: initStates,
  effects: {
    * onMount_Page({ }: OnMount_Page_Action, { call, put }: EffectsCommandMap) {
      // const params1: Parameters<typeof FServiceAPI.Statistic.transactionsCommon>[0] = {
      //   ownerId: FUtil.Tool.getUserIDByCookies(),
      //   ownerType: 1,
      //   objectType: 2,
      // };
      // const { data: data_Resource_Total_Amount } = yield call(FServiceAPI.Statistic.transactionsCommon, params1);

      const params1: Parameters<typeof FServiceAPI.Payment.queryStatistics>[0] = {
        // ownerId: FUtil.Tool.getUserIDByCookies(),
        ownerType: 1,
        // startTransactionDate: get$dataTime().startDateTime + ' 00:00:00',
        // endTransactionDate: get$dataTime().endDateTime + ' 23:59:59',
      };
      const { data: data_Resource_Total_Amount }: {
        data: {
          depositAmount: number;
          withdrawalAmount: number;
        };
      } = yield call(FServiceAPI.Payment.queryStatistics, params1);

      // const params2: Parameters<typeof FServiceAPI.Statistic.transactionsCommon>[0] = {
      //   ownerId: FUtil.Tool.getUserIDByCookies(),
      //   ownerType: 1,
      //   objectType: 3,
      // };
      // const { data: data_Node_Total_Amount } = yield call(FServiceAPI.Statistic.transactionsCommon, params2);

      const params2: Parameters<typeof FServiceAPI.Payment.queryStatistics>[0] = {
        // ownerId: FUtil.Tool.getUserIDByCookies(),
        ownerType: 2,
        // objectType: 3,
      };
      const { data: data_Node_Total_Amount }: {
        data: {
          depositAmount: number;
          withdrawalAmount: number;
        };
      } = yield call(FServiceAPI.Payment.queryStatistics, params2);


      // const startTime: string = dayjs().subtract(1, 'months').format(FUtil.Predefined.momentDateFormat);
      const startTime: string = dayjs().subtract(29, 'days').format(FUtil.Predefined.momentDateFormat);
      const endTime: string = dayjs().format(FUtil.Predefined.momentDateFormat);
      // const params3: Parameters<typeof FServiceAPI.Statistic.transactionsCommon>[0] = {
      //   ownerId: FUtil.Tool.getUserIDByCookies(),
      //   ownerType: 1,
      //   objectType: 2,
      //   beginDate: startTime,
      //   endDate: endTime,
      // };
      // const { data: data_Resource_LastWeek_Amount } = yield call(FServiceAPI.Statistic.transactionsCommon, params3);

      const params3: Parameters<typeof FServiceAPI.Payment.queryStatistics>[0] = {
        // ownerId: FUtil.Tool.getUserIDByCookies(),
        ownerType: 1,
        startTransactionDate: startTime,
        endTransactionDate: endTime,
      };
      const { data: data_Resource_LastWeek_Amount }: {
        data: {
          depositAmount: number;
          withdrawalAmount: number;
        };
      } = yield call(FServiceAPI.Payment.queryStatistics, params3);

      // const params4: Parameters<typeof FServiceAPI.Statistic.transactionsCommon>[0] = {
      //   ownerId: FUtil.Tool.getUserIDByCookies(),
      //   ownerType: 1,
      //   objectType: 3,
      //   beginDate: startTime,
      //   endDate: endTime,
      // };
      // const { data: data_Node_LastWeek_Amount } = yield call(FServiceAPI.Statistic.transactionsCommon, params4);

      const params4: Parameters<typeof FServiceAPI.Payment.queryStatistics>[0] = {
        // ownerId: FUtil.Tool.getUserIDByCookies(),
        ownerType: 2,
        startTransactionDate: startTime,
        endTransactionDate: endTime,
      };
      const { data: data_Node_LastWeek_Amount }: {
        data: {
          depositAmount: number;
          withdrawalAmount: number;
        };
      } = yield call(FServiceAPI.Payment.queryStatistics, params4);

      const params5: Parameters<typeof FServiceAPI.Resource.list>[0] = {
        skip: 0,
        limit: 3,
        isSelf: 1,
        sort: 'createDate:-1',
      };
      const { data: data_ResourceList }: {
        data: {
          limit: number;
          skip: number;
          totalItem: number;
          dataList: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
            latestVersion: string;
            coverImages: string[];
            resourceType: string[];
            policies: {
              policyName: string;
              status: 0 | 1;
            }[];
            createDate: string;

            userId: number;
            updateDate: string;
            username: string;
            operationType: 0 | 1 | 2 | 3 | 4 | 5;

            subjectType: 1 | 4;
          }[];
        }
      } = yield call(FServiceAPI.Resource.list, params5);

      const params6: Parameters<typeof FServiceAPI.Node.nodes>[0] = {
        limit: FUtil.Predefined.pageSize,
      };
      const { data: data_AllNodes } = yield call(FServiceAPI.Node.nodes, params6);

      const params7: Parameters<typeof FServiceAPI.Contract.contractsSignCount>[0] = {
        objectIds: FUtil.Tool.getUserIDByCookies(),
        objectType: 2,
        subjectType: 1,
        startDate: startTime,
        endDate: endTime,
      };

      const { data: data_Resource_LastWeek_SingCount } = yield call(FServiceAPI.Contract.contractsSignCount, params7);

      const params8: Parameters<typeof FServiceAPI.Contract.contractsSignCount>[0] = {
        objectIds: FUtil.Tool.getUserIDByCookies(),
        objectType: 2,
        subjectType: 2,
        startDate: startTime,
        endDate: endTime,
      };

      const { data: data_Node_LastWeek_SingCount } = yield call(FServiceAPI.Contract.contractsSignCount, params8);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resourceStatistic: {
            totalProfit: data_Resource_Total_Amount.depositAmount.toFixed(2),
            lastWeekProfit: data_Resource_LastWeek_Amount.depositAmount.toFixed(2),
            lastWeekContract: data_Resource_LastWeek_SingCount[0].count,
          },
          latestResources: data_ResourceList.dataList.map<DashboardPageModelState['latestResources'][number]>((r) => {
            return {
              resourceID: r.resourceId,
              resourceName: r.resourceName,
              resourceTitle: r.resourceTitle,
              cover: r.coverImages[0] || '',
              type: r.resourceType,
              policies: r.policies
                .filter((p) => {
                  return p.status === 1;
                })
                .map((p) => {
                  return p.policyName;
                }),
              dataTime: FUtil.Format.formatDateTime(r.createDate, true),
              detailUrl: FUtil.LinkTo.resourceDetails({ resourceID: r.resourceId }),
              // editUrl: FUtil.LinkTo.resourceInfo({ resourceID: r.resourceId }),
              editUrl: FUtil.LinkTo.resourceVersionInfo({
                resourceID: r.resourceId,
                version: r.latestVersion || undefined,
              }),
              updateUrl: r.subjectType === 4
                ? ''
                : FUtil.LinkTo.resourceVersionCreator({ resourceID: r.resourceId }),

              updateDate: dayjs(r.updateDate).format(FUtil.Predefined.momentDateFormat),
              username: r.username,
              useAvatar: `${AVATAR_URL_PREFIX}${r.userId}`,
              isChoice: r.operationType === 5,
              // isCollection: r.subjectType === 4,
            };
          }),
          nodeStatistic: {
            totalProfit: data_Node_Total_Amount.depositAmount.toFixed(2),
            lastWeekProfit: data_Node_LastWeek_Amount.depositAmount.toFixed(2),
            lastWeekContract: data_Node_LastWeek_SingCount[0].count,
          },
          allNode: (data_AllNodes.dataList as any[]).map<DashboardPageModelState['allNode'][number]>((dl: any, i: number) => {
            return {
              nodeID: dl.nodeId,
              nodeDomain: dl.nodeDomain,
              nodeName: dl.nodeName,
              displayUrl: FUtil.Format.completeUrlByDomain(dl.nodeDomain),
              managingUrl: FUtil.LinkTo.nodeManagement({ nodeID: dl.nodeId }),
            };
          }),
        },
      });
    },
    * onUnmount_Page({ }: OnUnmount_Page_Action, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: initStates,
      });
    },
    * fetchInfo({ }: FetchInfoAction, { }: EffectsCommandMap) {

    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({ }) {

    },
  },
};

export default Model;
